(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[946],{

/***/ 8271:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tool/map/directory",
      function () {
        return __webpack_require__(6519);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_head_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4058);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9521);
/* harmony import */ var _components_tools_map_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9643);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5740);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  min-height: 100%;\n  display: none;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: var(--size-3);\n\n  padding-top: var(--size-6);\n\n  ",
        " {\n    display: flex;\n    padding: var(--size-6) var(--size-3) var(--size-3) 60vw;\n    align-items: center;\n    justify-content: center;\n    font-size: var(--text-h1-font-size);\n    color: var(--color-medium-grey);\n    font-family: var(--font-family-monospace);\n    line-height: 1.3em;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Content = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-eddbf254-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.applyMixin("noPrint");
});
var Directory = function(param) {
    var tool = param.tool;
    var ref;
    var currentTool = (ref = _config__WEBPACK_IMPORTED_MODULE_4__/* .appConfig.tools */ .e.tools) === null || ref === void 0 ? void 0 : ref.find(function(t) {
        return t.slug === "map";
    });
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_head_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "Directory - ".concat((currentTool === null || currentTool === void 0 ? void 0 : currentTool.name) ? "".concat(currentTool === null || currentTool === void 0 ? void 0 : currentTool.name, " - ") : "", " ").concat(_config__WEBPACK_IMPORTED_MODULE_4__/* .appConfig.appTitle */ .e.appTitle),
                description: (ref1 = currentTool === null || currentTool === void 0 ? void 0 : currentTool.description) !== null && ref1 !== void 0 ? ref1 : undefined,
                og: {
                    title: "Directory - ".concat((currentTool === null || currentTool === void 0 ? void 0 : currentTool.name) ? "".concat(currentTool === null || currentTool === void 0 ? void 0 : currentTool.name, " - ") : "", " ").concat(_config__WEBPACK_IMPORTED_MODULE_4__/* .appConfig.appTitle */ .e.appTitle),
                    siteName: _config__WEBPACK_IMPORTED_MODULE_4__/* .appConfig.appTitle */ .e.appTitle
                },
                twitter: {
                    card: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Content, {
                children: [
                    "Select a project from ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "the list on the left ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "to explore the details."
                ]
            })
        ]
    });
};
Directory.getLayout = function getLayout(page, props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_tools_map_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        props: props,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Directory);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [471,619,917,47,643,774,888,179], function() { return __webpack_exec__(8271); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);